module.exports = __webpack_public_path__ + "static/img/img_gift03.png";